import { chowbus_kiosk_video_id } from 'src/consts/resource';
const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering.png`,
      title: 'Self Ordering Kiosks',
      description: `Reduce wait-times, enhance the guest experience with Self Ordering Kiosks!`,
      youtubeVideoId: chowbus_kiosk_video_id.en,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering.png`,
      title: '智能自助点餐机',
      description: `集自助点餐和支付为一体的多功能点餐设备，在有效减少等待时间、人力成本的同时，提升用餐体验`,
      youtubeVideoId: chowbus_kiosk_video_id.zh,
    },
  },
  advances: {
    en: {
      title: `Reduce wait-times, enhance the guest experience!`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_feature_1.png`,
          imageAlt: 'Convenience & Contactless',
          title: 'Convenience & Contactless',
          description:
            'Empower your guests to place and customize their orders independently. Orders are sent directly to the kitchen through Chowbus All-in-one POS system.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_feature_2.png`,
          imageAlt: 'Maximum Efficiency',
          title: 'Maximum Efficiency',
          description: 'Remove redundant tasks for your staff and focus their time on improving the guest experience.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_feature_3.png`,
          imageAlt: 'Fully Integrated Experience',
          title: 'Fully Integrated Experience',
          description: 'Send orders directly from the guest to the kitchen from the kiosk.',
        },
      ],
    },
    zh: {
      title: `使用Chowbus智能⾃助点餐机，帮助您的餐厅节约人力成本，
      降低顾客等候时间，并大大提升客单价。`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_feature_1.png`,
          imageAlt: '无接触的点餐体验',
          title: '无接触的点餐体验',
          description: '顾客可以根据菜品图片、描述等自助下单、支付',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_feature_2.png`,
          imageAlt: '高效的出餐速度',
          title: '高效的出餐速度',
          description: `餐品自动发送到厨房打印机，
          店员仅需专注地准备餐品，提升出餐效率`,
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_feature_3.png`,
          imageAlt: '有效的产品组合',
          title: '有效的产品组合',
          description: `智能点餐机+短信通知，可以提供更优的顾客等餐体验；
            智能点单机+会员系统，可以有效提升会员数和复购率`,
        },
      ],
    },
  },

  features: {
    en: {
      title:
        'Eliminate lines, free up employees’ time, and give customers what they want with a custom-designed experience.',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: 'Accelerate the Guest Experience',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_advance_1.png`,
          items: [
            {
              desc: 'Give guests the freedom to choose what they like. Guests can customize their order with available add-on’s and modifiers.',
            },
            {
              desc: `Guests can also opt-in to SMS text updates about their order. No more missing orders.`,
            },
            { desc: 'Allows guests to toggle between language settings! Save big on print menus.' },
          ],
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: 'Save Operating Cost',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_advance_2.png`,
          items: [
            {
              desc: 'Cut Labor Cost by $8,000 per month: Orders placed on the Kiosk will be sent to the kitchen directly through our All-in-one POS system. No need for the waiter to input the order manually. With guests ordering on their own, free up staff to handle important tasks elsewhere.',
            },
            {
              desc: 'Reduce Wait Times: Hungry customers hate waiting in lengthy lines. With guests ordering on their own, there will be no back-and-forth between cashier and guest, wait times are reduced significantly.',
            },
            { desc: 'Real-time Menu Changes: Cloud data sync, real-time price change, save the paper menu cost.' },
          ],
        },

        {
          layout: 'row',
          direction: 'normal',
          title: 'Improve Profit and Order Size',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_advance_4.png`,
          items: [
            {
              desc: 'Increase Order Size: With Chowbus Kiosk, there’s an option to push upsell prompts as guests are building their orders, including special promotions, adding extra paid toppings, or making a meal a combo. Guests have full control of adding items and customization, increasing average order size and tips by 25%.',
            },
            {
              desc: 'Reward Guests: Chowbus Kiosk allows for restaurants’ own loyalty programs and restaurants can offer coupons and cash backs to reward their loyal customers with more options that help with retaining the customer for future visits.',
            },
          ],
        },
      ],
    },
    zh: {
      title: `Chowbus智能自助点餐机可以有效缩短排队队伍，
      降低人力成本，提高餐厅利润，提升顾客点餐体验和好感度`,
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '优质的点餐体验',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_advance_1.png`,
          items: [
            { desc: '顾客可以在大屏点单机自助浏览菜单并下单、支付，全流程自助' },
            { desc: `清晰的餐品图在大屏上更加吸睛，有效帮助顾客了解餐品并吸引顾客下单` },
            { desc: '顾客自由选择甜度、小料等附加选项，显著提升客单价' },
            { desc: '短信通知餐品制作进度，优化顾客的等餐、取餐体验' },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '高效的运营模式',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_advance_2.png`,
          items: [
            {
              desc: `扫码下单的订单会自动发送至后厨，减少传递菜品信息的人力和时间成本`,
            },
            { desc: '扫码点单产品精简店员的服务流程，有效减少月均$8,000的人力成本的同时，提升25%的翻台率' },
            { desc: '利用扫码点餐✖️会员系统，顾客可以注册会员、积累积分并兑换菜品，有效提升顾客黏性' },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: '卓越的运营效率',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_kiosk_ordering_advance_4.png`,
          items: [
            {
              desc: '订单会自动发送至后厨，减少传递菜品信息的人力和时间成本',
            },
            { desc: '精简店员的服务流程，有效减少月均$8,000的人力成本的同时，提升出餐效率' },
            { desc: '缩短顾客等待时间的同时，增加单日订单数和营业额' },
            { desc: '在云端更新电子菜单，即可同步到智能点单机等POS设备上，节省纸质印刷费用' },
          ],
        },
      ],
    },
  },

  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-teamobobabar.jpeg`,
      productLine: 'Kiosk',
      desc: {
        zh: `芝加哥非常火爆的奶茶店，享茶，选择使用Chowbus的智能⾃助点餐机作为最主要的点餐方式。顾客通过使用智能⾃助点餐机下单，不但实现了无接触自主点餐，更让订餐效率大大增加，有效地缩短了排队，降低了人力成本，提高了餐厅利润，最重要的是提升了顾客的点餐体验和好感度。`,
        en: `Te'amo Boba Bar, a busy quick-service boba tea shop. Where speed, efficiency, and accuracy take priority, Chowbus Kiosk Ordering, the Guest-Facing Display, helps deliver delight during the rush at Te'amo Boba Bar. `,
      },
      restaurantName: { zh: `享茶`, en: `Te'amo Boba Bar` },
      location: { zh: '芝加哥', en: 'Chicago, IL' },
      link: '/business-types/boba-tea-dessert/teamo-boba-bar',
    },
  ],
};

export default SectionContent;
